var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page-plus',[_c('div',{class:_vm._.message},[_vm._v("请返回APP查看订单")])])}
var staticRenderFns = []

export { render, staticRenderFns }